
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {AuthenticationService} from '../services/apiServices/security/authentication.service';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {StorageService} from '../services/storage/storage.service';

/**
 * Guard handling access to url with protected access
 */
@Injectable()
export class AuthGuard {

  /**
   *
   * instantiate param (if not done yet)
   *
   * @param {AuthenticationService} authService - required to verify the access
   * @param {Router} router - required to handleChangeOfSelectFold routing
   * @param {StorageService} storageService -required to directly handleChangeOfSelectFold token
   */
  constructor(private authService: AuthenticationService, private router: Router, private storageService: StorageService) {
  }

  /**
   *
   * determines if a user can access to a special route
   *
   * @param {ActivatedRouteSnapshot} route - required for the guard
   * @param {RouterStateSnapshot} state - the current state of the router
   * @returns {Observable<boolean>} - true if the access is authorized, else false
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    if (!this.storageService.getTokenFromStorage()) {
      this.router.navigate([''], {queryParams: {returnUrl: state.url}});
      return of(false);
    }
    else {
      return this.authService.checkTokenValidity().pipe(map(result => {
        if (result) {
          return true;
        } else {
          this.router.navigate([''], {queryParams: {returnUrl: state.url}});
          return false;
        }
      }));
    }
  }

}



